import AccountCreation from "@/components/signup/account-creation";
import { LoomOverlayTemplate } from "@/components/signup/layouts";
import { useFeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { useIsMobile } from "@/utils/useIsMobile";

import {
    InputSubmitButton,
    GetStartedHeading,
    SignupDefault
} from "../../components";
import { FreeSubheading } from "../components/free-subheading";

export const LoggedOutLoom = () => {
    const isMobile = useIsMobile(800);

    useFeatureExposed("gwp-7282-loom-lofi-signup", "Test", {
        conditions: [!isMobile],
        metadata: {
            userType: "logged-out"
        }
    });

    const accountCreationEnabled = checkFeatureFlagGate(
        featureFlags.identityCommitAccountCreationLoom
    );

    if (!isMobile || accountCreationEnabled) {
        return (
            <LoomOverlayTemplate size="sm">
                <Content />
            </LoomOverlayTemplate>
        );
    } else {
        return <SignupDefault />;
    }
};

const Content = () => (
    <>
        <GetStartedHeading productName="Loom" />
        <FreeSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </>
);
